/*
 * @Description: 房源维护列表
 * @Author: 段生华
 * @Date: 2019-05-07 17:20:24
 * @LastEditTime: 2019-07-04 11:51:33
 * @LastEditors: Please set LastEditors
 */

import React from 'react';
import {Button, message, Divider, Popconfirm, Upload, Modal, Spin} from 'antd';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import {postFrom, config, transterQuery, post, uploadNewEnclosure, uploadNew1Enclosure} from '../../axios';
import {acceptStatusIsMap, checkStatusIsMap, dicHouseStatus, syncStatusIsMap} from '../../axios/dictionaries';
import {formatTime, handleExportParams, isPlatform} from '../../utils';
import JrApiLog from "../Other/JrApiLog";
import HouseTypeDetail from "./detail";
import DeviceDetail from "./deviceDetail";
import moment from "moment";
import {
    API_device_importAcceptanceDate,
    API_report_deviceImportAcceptanceTemplate,
    API_report_deviceImportDeviceBillTemplate,
    API_roomType_asyncBatchCheck
} from "../../axios/config";

export default class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                shortName: '',
                buildingNo: '',
                projectKeyword:'',
                floor: '',
                roomNo: '',
                keyword: '',
                syncStatus:'',
                status: '',
                pageSize: 10,
            },
            current: 1, //当前页
            showBillImportModal:false,  //批量导入账单弹窗
            billImporLoad:false,       //批量导入账单Loading
            billImportData:'',      //批量导入账单 数据显示
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showAddModal: false, //新增组件弹窗
        }

        let loginData = Cookies.get('loginData');
        if (loginData) { //校验登录是否失效
            loginData = JSON.parse(loginData);
            if (loginData.merchantId) {  //为商户人员添加商户id
                this.merchantId = loginData.merchantId || 0;
            }
        }
    }

    importBillProps = { //批量合同导入
        action: config.API_device_importAcceptanceDate,
        accept: '.xls',
        showUploadList: false,
        beforeUpload: (file) => {
            message.loading(`${file.name}上传中...`);
        },
        onChange: (info) => {
            if (info.file.status === 'done') {
                let res = info.file.response;
                if (res.code === 0) {
                    message.success(`${info.file.name}文件导入成功`);
                    if(res.data){
                        this.setState({showBillImportModal:true})
                        this.handleGetBillImportLog(res.data)
                    }
                } else {
                    if(Array.isArray(res.data)){
                        Modal.error({
                            className:'importModal',
                            title: res.message || `${info.file.name}文件导入失败`,
                            content: <div style={{whiteSpace:'pre',maxHeight:'80vh',overflow:'auto'}}>{res.data.join('\n')}</div> ,
                        });
                    }else{
                        message.error(res.message || `${info.file.name}文件导入失败`);
                    }
                }
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name}文件上传失败`);
            }
        },
    };

    handleGetBillImportLog = (id) => {  //获取批量导入账单的异步进程日志
        this.setState({showBillImportModal:true})
        this.billTimer = setInterval(()=>{
            postFrom({ url: config.API_device_getImportLog, data: { threadNo: id, } }).then(res => {
                console.log(res);
                if (res) {
                    this.setState({billImportData:res.replace(/\\r\\n/g,'\n')})
                    if(res.search("失败")){
                        clearInterval(this.billTimer)
                    }
                   //  Modal.error({
                   //      className:'importModal',
                   //      title: res.message || `${info.file.name}文件导入失败`,
                   //      content: <div style={{whiteSpace:'pre',maxHeight:'80vh',overflow:'auto'}}>{res.data.join('\n')}</div> ,
                   //  });
                   // clearInterval(this.billTimer)
                } else {
                    message.error(res.message ||  '操作失败!');
                    clearInterval(this.billTimer)
                }
            }).catch(err => {
                message.error(err.message || '操作异常!');
                clearInterval(this.billTimer)
            });
        },2000)
    }

    closeBillImport = ()=>{  //清除 批量账单导入定时器
        clearInterval(this.billTimer)
        this.handleSearch()
        this.setState({showBillImportModal:false})
    }

    componentDidMount() {
        this.handleSearch();
    }

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        let data = {};

        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        postFrom({ url: config.API_house_findHousePageList, data }).then(res => {
            this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }

    handleJrApiLogInfo(tableName,id) {
        //console.log(this);
        this.jrApiLogRef.open(tableName,id);
    }

    // handleEdit = (id) => { //编辑
    //     this.setState({ showAddModal: true });
    //     this.maintainAddRef.loadPack({ id });
    //     this.maintainAddRef.loadBuildingList();
    // }

    handleRemove = (id) => { //删除
        this.setState({ tableLoading: false });
        let data = { houseId: id };
        postFrom({ url: config.API_house_deleteHouse, data }).then(res => {
            this.setState({ tableLoading: false });
            this.handleSearch();
        }).catch(err => {
            message.error(err.message || '删除失败');
            this.setState({ tableLoading: false });
        });
    }
    handleEdit = (id) => {
        this.HouseTypeDetailRef.open(id).then(res => {
            this.handleSearch()
        })
    }

    handleInfo = (id) => {
        this.DeviceDetailRef.open(id).then(res => {
            this.handleSearch()
        })
    }
    postAsyncBatchCheck(id) {
        return post({ url: API_roomType_asyncBatchCheck  +'?id=' + id }).then(() => {
            message.success('批量核对中，请稍后刷新页面')
        }).catch(e => {
            message.error(e.message)
        })
    }
    handleAsyncBatchCheck() {
        this.postAsyncBatchCheck().then(() =>{
            this.handleSearch()
        })
    }

    renderUploadWrap (action,success,data = {}) {
        const uploadConfig = uploadNew1Enclosure({
            //批量账单导入
            action: action,
            accept: '.xls',
            tableName: 'rent_contract', success: this.uploadContract, attachType: 5
        })
        return (
            <Upload {...uploadConfig}>
                <Button type="primary" icon="import">导入房源验收日期</Button>
            </Upload>
        )
    }

    handleAsyncOperationDate() {
        this.postAsyncBatchCheck().then(() =>{
            this.handleSearch()
        })
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
        } = this.state;
        this.importBillProps.headers = { ...(handleExportParams() || {}) };
        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper">
                    <div className="search-btn-list">
                        <AuthButton authkey="z-1-2" type="primary" icon="export">
                            <Popconfirm title="确认一键生成吗" onConfirm={this.handleAsyncBatchCheck.bind(this)}>
                                <a>一键核对</a>
                            </Popconfirm>
                        </AuthButton>
                        <AuthButton authkey="z-1-3" type="primary" icon="export" href={`${config.API_report_deviceImportDeviceBillTemplate}?${transterQuery(Object.assign({}, handleExportParams() || {}, this.state.params, { current }))}`}>
                            下载设备账单
                        </AuthButton>
                        <AuthButton authkey="z-1-9" type="primary" icon="export" href={`${config.API_report_deviceImportAcceptanceTemplate}?${transterQuery(Object.assign({}, handleExportParams() || {}, this.state.params, { current }))}`}>
                            验收日期下载
                        </AuthButton>
                        <AuthButton authkey="z-1-8" type="primary" icon="import">
                            <Upload {...this.importBillProps}><Button type="primary" icon="import">批量更新验收日期</Button></Upload>
                        </AuthButton>
                    </div>
                    <SuperForm
                        data={searchData()}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                </div>
                <TableDOM
                    columns={columns({ current, handleEdit: this.handleEdit, handleInfo: this.handleInfo,handleJrApiLogInfo:this.handleJrApiLogInfo.bind(this) })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    current={current}
                    onChange={this.handleSearch}
                    scroll={{x: 1500}}
                />
                {/* 批量账单导入 */}
                <Modal
                    destroyOnClose
                    maskClosable={false}
                    visible={this.state.showBillImportModal}
                    onCancel={this.closeBillImport}
                    footer={<Button onClick={this.closeBillImport} type="primary">确定</Button>}
                >
                    <Spin spinning={this.state.billImporLoad}>
                        <div style={{maxHeight:'80vh',overflow:'auto',padding:'30px',whiteSpace:'pre'}}>
                            {this.state.billImportData}
                        </div>
                    </Spin>
                </Modal>
                <JrApiLog ref={ref=>{
                    this.jrApiLogRef=ref;
                }}/>
                <HouseTypeDetail wrappedComponentRef={ ref=> this.HouseTypeDetailRef = ref } />
                <DeviceDetail wrappedComponentRef={ ref=> this.DeviceDetailRef = ref } />
            </PageWrap>
        )
    }


}

const searchData = () => {
    let data =  [
        {
            tagName: 'Input',
            formConfig: { name: 'buildingNo' },
            attribute: { placeholder: '请输入小区/楼栋', style: { width: '130px' } },
        },
        {
            tagName: 'Input',
            formConfig: { name: 'projectKeyword' },
            attribute: { placeholder: '请输入项目名称', style: { width: '200px' } },
        },
        {
            tagName: 'Input',
            formConfig: { name: 'floor' },
            attribute: { placeholder: '请输入楼层', style: { width: '130px' } },
        },
        {
            tagName: 'Input',
            formConfig: { name: 'roomNo' },
            attribute: { placeholder: '请输入房号', style: { width: '130px' } },
        },
        {
            tagName: 'Select',
            formConfig: { name: 'acceptStatus' },
            attribute: { placeholder: '请选择验收状态', style: { width: '140px' } },
            optionData: [{ title: '全部', value: '' }].concat(acceptStatusIsMap), //.concat(dicHouseStatus)
            notResult: '',
        },
        {
            tagName: 'Select',
            formConfig: { name: 'checkStatus' },
            attribute: { placeholder: '请选择核对状态', style: { width: '140px' } },
            optionData: [{ title: '全部', value: '' }].concat(checkStatusIsMap), //.concat(dicHouseStatus)
            notResult: '',
        },
        {
            tagName: 'InputTip',
            formConfig: { name: 'keyword' },
            attribute: { placeholder: '输入关键字', style: { width: '160px' } },
            title: `在${handleExportParams().merchantId ? '' : '商户简称、'}小区/楼栋、房号内模糊查询`
        }
]

   /* data = data.filter(e => {
        if(isPlatform()){
            return true;
        }
        if (e.formConfig.name === 'syncStatus') {
            return false;
        }
        return true;
    });*/

    return data;
};

const columns = ({ handleEdit, handleInfo,handleJrApiLogInfo }) => [
    {
        title: '房源编号',
        dataIndex: 'houseNo'
        , width:200 ,fixed: 'left'
    },
    {
        title: '房号',
        dataIndex: 'roomNo'
        , width:80 ,fixed: 'left'
    },
    {
        title: '小区/楼栋',
        dataIndex: 'buildingName'
        , width:200
    },
    {
        title: '楼层',
        dataIndex: 'floor'
        , width:60
    },
    {
        title: '户型',
        dataIndex: 'layout'
        , width:180
    },
    {
        title: '面积（m²）',
        dataIndex: 'area'
    },
    {
        title: '验收日期',
        dataIndex: 'acceptanceDate'
        ,render: text => formatTime(text, 'YYYY-MM-DD')
    },
    {
        title: '运营开始日期',
        dataIndex: 'operationStartDate'
        ,render: text => formatTime(text, 'YYYY-MM-DD')
    },
    {
        title: '运营结束日期',
        dataIndex: 'operationEndDate'
        ,render: text => formatTime(text, 'YYYY-MM-DD')
    },
    {
        title: '收租日(每月)',
        dataIndex: 'collectionDay'
    },
    {
        title: '设备总租金(元)',
        dataIndex: 'deviceTotalRent',
        render(text, record, index) {
            return <span>
                <div>{record.deviceTotalRent ? record.deviceTotalRent : "-"}</div>
            </span>
        }
    },
    {
        title: '是否核对',
        dataIndex: 'checkState',
        render(text, record, index) {
            return <span>
                <div>{record.checkState===1 ? '已核对' : "未核对"}</div>
            </span>
        }
    },
    {
        title: '项目名称(已核对)',
        dataIndex: 'projectName'
    },
    {
        title: '核对时间',
        dataIndex: 'checkTime'
    },
    {
        title: '商户简称',
        dataIndex: 'shortName'
    },
    {
        title: '操作',
        dataIndex: 'action',
        width: 200,
        fixed: 'right',
        render(text, record, index) {
            const rentLink = {
                pathname: '/admin/operate/repairReport',
                state: { houseId: record.id }
            }
            return <span>
                 {record.checkState==null||record.checkState===2?<AuthButton authkey="z-1-5">
                    <a  onClick={() => { handleEdit(record.id) }}>核对清单</a>
                </AuthButton>:null}
                {record.checkState!=null&&record.checkState===1?<AuthButton authkey="z-1-4">
                    <a  onClick={() => { handleInfo(record.id) }}>设备清单</a >
                </AuthButton>:null}
                    {record.checkState!=null&&record.checkState===1?<AuthButton authkey="z-1-7">
                        <Divider type="vertical" />
                        <Link to={rentLink}>报修记录</Link>
                </AuthButton>:null}
            </span>
        }
    }
];


// WEBPACK FOOTER //
// ./src/page/OperateHouse/Maintain.js